import React from "react";
import { Link } from "react-router-dom";

export default function JoinCultureCta() {
  return (
    <section className="mu-section pt-0">
      <div className="container">
        <div className="share-sound-cta">
          <div>
            <h3>Ready to Join the Culture?</h3>
            <p>Whether you're an artist, a fan, or a brand — there's a place for you here.</p>
          </div>
          <Link to="/services" className="btn-mu-solid flex-shrink-0">Get Started &rarr;</Link>
        </div>
      </div>
    </section>
  );
}
